module.exports = __webpack_public_path__ + "static/media/Yorick.bef9327d.png";